import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  // Don't set Content-Type header here - it will be set automatically for FormData
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const countryService = {
  getCountries: async () => {
    try {
      console.log('Fetching countries from:', `${config.API_URL}/countries`);
      const response = await api.get('/countries');
      console.log('Countries response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching countries:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  },

  getCountryById: async (id) => {
    const response = await api.get(`/countries/${id}`);
    return response.data;
  },

  addCountry: async (formData) => {
    console.log("=== ADD COUNTRY DEBUG ===");
    
    // Log FormData content
    console.log('FormData entries:');
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
      if (value instanceof File) {
        console.log('  - File details:', {
          name: value.name,
          size: value.size,
          type: value.type
        });
      }
    }

    try {
      // No need to manually set headers - axios will handle multipart/form-data
      const response = await api.post('/countries', formData);
      console.log('Country created with image:', response.data);
      return response.data;
    } catch (error) {
      console.error('=== ERROR DETAILS ===');
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      console.error('Error headers:', error.response?.headers);
      throw error;
    }
  },

  deleteCountry: async (id) => {
    const response = await api.delete(`/countries/${id}`);
    return response.data;
  }
};

export default countryService;